<template>
  <default>
    <div id="projects_main">

    </div>
  </default>
</template>

<script>
  import Default from '../components/layouts/Default'
  export default {
    name: 'Projects',
    components: { Default },
    data(){
      return{

      }
    },
    methods: {

    },
    computed: {

    },
    mounted(){

    }
  }
</script>

<style scoped>
  #projects_main{
    display: flex;
    width: 100%;
  }
</style>
